<template>
  <lu-vbox :class="{'has-logo':showLogo}">
    <!-- <logo v-if="showLogo" :collapse="isCollapse" /> -->

    <!-- <el-scrollbar class='elu-flex' wrap-class="scrollbar-wrapper"> -->
    <lu-scroll-area lu-flex style='height: 100%;'>
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in permission_routers" :key="route.path" :item="route" :base-path="route.path"/>
      </el-menu>
    </lu-scroll-area>
    <!-- </el-scrollbar> -->

    <lu-item lu-flex lu-click style="padding: 5px 0px">
      <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    </lu-item>


  </lu-vbox>
</template>

<script>
import { LuVbox, LuItem, LuScrollArea } from 'lusis-ui'
import { mapGetters } from 'vuex'
// import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variable from '@/styles/variables.scss'
import Hamburger from '@/components/Hamburger'

export default {
  components: { LuVbox, SidebarItem, Hamburger, LuItem, LuScrollArea },
  created: function () {

  },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    routes() {
      return this.$router.options.routes
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route

      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variable
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    }
  }
}
</script>
